import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text, buttons" theme="lightest" className="how-it-work-richText padding-bottom-zero-child partner-with-us-cta" mdxType="TextBlock" />
    <h3 {...{
      "id": "partner-with-us"
    }}>{`Partner with us.`}</h3>
    <p>{`Acrobat Sign can help transform and speed up your workflow while creating  a better experience for your customers. Join  other top companies and partner with us to get access to private APIs and addtional resources that empower you to embed e-signature and PDF features into your mobile app, website, or SaaS platform.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/documentcloud/integrations/isv-partner-form.html"
        }}>{`Get started`}</a></li>
    </ul>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-ms-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "348px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "21.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/24a8bdd2c884db9d509c8e1465d6f15b/5530d/7_Logo_Microsoft.webp 320w", "/document-services/static/24a8bdd2c884db9d509c8e1465d6f15b/b4669/7_Logo_Microsoft.webp 348w"],
            "sizes": "(max-width: 348px) 100vw, 348px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/24a8bdd2c884db9d509c8e1465d6f15b/dd4a7/7_Logo_Microsoft.png 320w", "/document-services/static/24a8bdd2c884db9d509c8e1465d6f15b/9c78a/7_Logo_Microsoft.png 348w"],
            "sizes": "(max-width: 348px) 100vw, 348px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/24a8bdd2c884db9d509c8e1465d6f15b/9c78a/7_Logo_Microsoft.png",
            "alt": "Microsoft logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-ms-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "250px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.6%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a5b9e76dada920e171b418bbeb567759/23cfa/7_Logo_SAP.webp 250w"],
            "sizes": "(max-width: 250px) 100vw, 250px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a5b9e76dada920e171b418bbeb567759/86700/7_Logo_SAP.png 250w"],
            "sizes": "(max-width: 250px) 100vw, 250px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a5b9e76dada920e171b418bbeb567759/86700/7_Logo_SAP.png",
            "alt": "SAP logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-ms-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "368px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "38.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3b65361db3b0f3f6c9193416e86d5018/5530d/7_Logo_workday.webp 320w", "/document-services/static/3b65361db3b0f3f6c9193416e86d5018/ef070/7_Logo_workday.webp 368w"],
            "sizes": "(max-width: 368px) 100vw, 368px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3b65361db3b0f3f6c9193416e86d5018/dd4a7/7_Logo_workday.png 320w", "/document-services/static/3b65361db3b0f3f6c9193416e86d5018/55493/7_Logo_workday.png 368w"],
            "sizes": "(max-width: 368px) 100vw, 368px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/3b65361db3b0f3f6c9193416e86d5018/55493/7_Logo_workday.png",
            "alt": "Workday logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-ms-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "69.75806451612904%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/bf2c243006a231edbc2e0fc706d4e6ce/1c148/7_Logo_salesforce.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/bf2c243006a231edbc2e0fc706d4e6ce/6fa18/7_Logo_salesforce.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/bf2c243006a231edbc2e0fc706d4e6ce/6fa18/7_Logo_salesforce.png",
            "alt": "Salesforce logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-ms-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "428px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "14.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0ed640f7f4023cb189741eb44abcab72/5530d/7_Logo_servicenow.webp 320w", "/document-services/static/0ed640f7f4023cb189741eb44abcab72/2a2ec/7_Logo_servicenow.webp 428w"],
            "sizes": "(max-width: 428px) 100vw, 428px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0ed640f7f4023cb189741eb44abcab72/dd4a7/7_Logo_servicenow.png 320w", "/document-services/static/0ed640f7f4023cb189741eb44abcab72/6c1f8/7_Logo_servicenow.png 428w"],
            "sizes": "(max-width: 428px) 100vw, 428px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0ed640f7f4023cb189741eb44abcab72/6c1f8/7_Logo_servicenow.png",
            "alt": "Servicenow logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      